(function () {
  'use strict';

  if (window.LivvewellBundleBuilder && window.LivvewellBundleBuilder.__loaded) {
    return;
  }

  var API = window.LivvewellBundleBuilder || {};
  API.__loaded = true;
  API.instances = API.instances || [];
  window.LivvewellBundleBuilder = API;


  function qs(root, selector) {
    return root ? root.querySelector(selector) : null;
  }

  function qsa(root, selector) {
    return root ? Array.prototype.slice.call(root.querySelectorAll(selector)) : [];
  }

  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

  function escapeHTML(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }


  function Builder(root) {
    this.root = root;

    this.tabs = qsa(root, '[data-lw-bundle-tab]');
    this.panels = qsa(root, '[data-lw-bundle-panel]');
    this.summary = qs(root, '[data-lw-bundle-summary]');
    this.empty = qs(root, '[data-lw-bundle-empty]');
    this.itemsWrap = qs(root, '[data-lw-bundle-items]');

    this.subtotalNode = qs(root, '[data-lw-bundle-subtotal]');
    this.savingsNode = qs(root, '[data-lw-bundle-savings]');
    this.totalNode = qs(root, '[data-lw-bundle-total]');

    this.progressLabel = qs(root, '[data-lw-bundle-progress-label]');
    this.progressValue = qs(root, '[data-lw-bundle-progress-value]');
    this.progressBar = qs(root, '[data-lw-bundle-progress-bar]');
    this.nextTierNode = qs(root, '[data-lw-bundle-next-tier]');

    this.checkout = qs(root, '[data-lw-bundle-checkout]');
    this.checkoutLabel = qs(root, '[data-lw-bundle-checkout-label]');
    this.errorNode = qs(root, '[data-lw-bundle-error]');

    this.mobileCount = qs(root, '[data-lw-bundle-mobile-count]');
    this.mobileSaving = qs(root, '[data-lw-bundle-mobile-saving]');
    this.mobileTotal = qs(root, '[data-lw-bundle-mobile-total]');
    this.mobileCheckout = qs(root, '[data-lw-bundle-mobile-checkout]');

    this.summaryOpen = qs(root, '[data-lw-bundle-summary-open]');
    this.summaryClose = qs(root, '[data-lw-bundle-summary-close]');
    this.summaryBackdrop = qs(root, '[data-lw-bundle-summary-backdrop]');

    this.currency = root.dataset.currency || 'USD';
    this.minimumItems = parseInt(root.dataset.minItems || '2', 10);

    this.showSavings = root.dataset.showSavings !== 'false';
    this.autoOpenCart = root.dataset.autoOpenCart !== 'false';

    this.tiers = [
      {
        count: parseInt(root.dataset.tierOneCount || '2', 10),
        discount: parseFloat(root.dataset.tierOneDiscount || '0')
      },
      {
        count: parseInt(root.dataset.tierTwoCount || '3', 10),
        discount: parseFloat(root.dataset.tierTwoDiscount || '0')
      },
      {
        count: parseInt(root.dataset.tierThreeCount || '4', 10),
        discount: parseFloat(root.dataset.tierThreeDiscount || '0')
      }
    ].sort(function (a, b) {
      return a.count - b.count;
    });

    this.items = {};
    this.busy = false;

    this.bind();
    this.update();
    this.track('bundle_builder_view', {});
  }


  Builder.prototype.bind = function () {
    var self = this;

    this.tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        self.activatePanel(tab.dataset.lwBundleTab, true);
      });
    });

    this.root.addEventListener('change', function (event) {
      var select = event.target.closest('[data-lw-bundle-variant]');

      if (!select || select.tagName !== 'SELECT') return;

      self.syncVariant(select);
    });

    this.root.addEventListener('click', function (event) {
      var add = event.target.closest('[data-lw-bundle-add]');

      if (add) {
        self.addFromCard(add);
        return;
      }

      var remove = event.target.closest('[data-lw-bundle-remove]');

      if (remove) {
        self.remove(remove.dataset.variantId);
        return;
      }

      var help = event.target.closest('[data-lw-bundle-help]');

      if (help) {
        self.openSupportFinder();
        return;
      }
    });

    qsa(document, '[data-lw-bundle-help]').forEach(function (button) {
      if (self.root.contains(button)) return;

      button.addEventListener('click', function () {
        self.openSupportFinder();
      });
    });

    if (this.checkout) {
      this.checkout.addEventListener('click', function () {
        self.addBundleToCart();
      });
    }

    if (this.mobileCheckout) {
      this.mobileCheckout.addEventListener('click', function () {
        self.addBundleToCart();
      });
    }

    if (this.summaryOpen) {
      this.summaryOpen.addEventListener('click', function () {
        self.openMobileSummary();
      });
    }

    if (this.summaryClose) {
      this.summaryClose.addEventListener('click', function () {
        self.closeMobileSummary();
      });
    }

    if (this.summaryBackdrop) {
      this.summaryBackdrop.addEventListener('click', function () {
        self.closeMobileSummary();
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        self.closeMobileSummary();
      }
    });
  };


  Builder.prototype.activatePanel = function (id, shouldTrack) {
    this.tabs.forEach(function (tab) {
      var active = tab.dataset.lwBundleTab === id;

      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    this.panels.forEach(function (panel) {
      var active = panel.dataset.lwBundlePanel === id;

      panel.hidden = !active;
      panel.classList.toggle('is-active', active);
    });

    if (shouldTrack) {
      var activeTab = this.tabs.find(function (tab) {
        return tab.dataset.lwBundleTab === id;
      });

      this.track('bundle_concern_selected', {
        concern: activeTab ? activeTab.textContent.trim() : id
      });
    }
  };


  Builder.prototype.variantNodeFromCard = function (card) {
    return qs(card, '[data-lw-bundle-variant]');
  };


  Builder.prototype.optionData = function (variantNode) {
    if (!variantNode) return null;

    if (variantNode.tagName === 'SELECT') {
      var option = variantNode.options[variantNode.selectedIndex];

      if (!option) return null;

      return {
        id: option.value,
        title: option.dataset.title || option.textContent.trim(),
        price: parseInt(option.dataset.price || '0', 10),
        priceMoney: option.dataset.priceMoney || '',
        available: option.dataset.available === 'true',
        image: option.dataset.image || ''
      };
    }

    return {
      id: variantNode.value,
      title: variantNode.dataset.title || '',
      price: parseInt(variantNode.dataset.price || '0', 10),
      priceMoney: variantNode.dataset.priceMoney || '',
      available: variantNode.dataset.available === 'true',
      image: variantNode.dataset.image || ''
    };
  };


  Builder.prototype.syncVariant = function (select) {
    var card = select.closest('[data-lw-bundle-product]');
    var data = this.optionData(select);

    if (!card || !data) return;

    var price = qs(card, '[data-lw-bundle-card-price]');
    var image = qs(card, '[data-lw-bundle-image]');
    var add = qs(card, '[data-lw-bundle-add]');
    var label = qs(card, '[data-lw-bundle-add-label]');

    if (price) {
      price.textContent = data.priceMoney || this.money(data.price);
    }

    if (image && data.image) {
      image.src = data.image;
      image.removeAttribute('srcset');
    }

    if (add) {
      add.disabled = !data.available;
      add.classList.toggle('is-added', !!this.items[String(data.id)]);
    }

    if (label) {
      if (!data.available) {
        label.textContent = 'Sold out';
      } else if (this.items[String(data.id)]) {
        label.textContent = 'Added';
      } else {
        label.textContent = 'Add to my bundle';
      }
    }

    this.track('bundle_variant_selected', {
      product_id: card.dataset.productId || '',
      variant_id: data.id,
      variant_title: data.title
    });
  };


  Builder.prototype.addFromCard = function (button) {
    var card = button.closest('[data-lw-bundle-product]');
    var variantNode = this.variantNodeFromCard(card);
    var variant = this.optionData(variantNode);

    if (!card || !variant || !variant.available) return;

    var key = String(variant.id);

    if (this.items[key]) {
      this.remove(key);
      return;
    }

    var image = qs(card, '[data-lw-bundle-image]');

    this.items[key] = {
      variantId: key,
      productId: card.dataset.productId || '',
      productTitle: card.dataset.productTitle || '',
      variantTitle: variant.title || '',
      concern: card.dataset.concern || '',
      price: variant.price,
      priceMoney: variant.priceMoney || this.money(variant.price),
      image: variant.image || (image ? image.currentSrc || image.src : ''),
      quantity: 1
    };

    button.classList.add('is-added');

    var label = qs(button, '[data-lw-bundle-add-label]');

    if (label) {
      label.textContent = 'Added';
    }

    this.update();

    this.track('bundle_product_added', {
      product_id: this.items[key].productId,
      variant_id: key,
      concern: this.items[key].concern,
      item_count: this.itemCount()
    });
  };


  Builder.prototype.remove = function (variantId) {
    var key = String(variantId || '');
    var existing = this.items[key];

    if (!existing) return;

    delete this.items[key];

    qsa(this.root, '[data-lw-bundle-product]').forEach(function (card) {
      var variantNode = qs(card, '[data-lw-bundle-variant]');
      if (!variantNode) return;

      var currentId =
        variantNode.tagName === 'SELECT'
          ? variantNode.value
          : variantNode.value;

      if (String(currentId) !== key) return;

      var add = qs(card, '[data-lw-bundle-add]');
      var label = qs(card, '[data-lw-bundle-add-label]');

      if (add) add.classList.remove('is-added');
      if (label) label.textContent = 'Add to my bundle';
    });

    this.update();

    this.track('bundle_product_removed', {
      product_id: existing.productId,
      variant_id: key,
      item_count: this.itemCount()
    });
  };


  Builder.prototype.itemCount = function () {
    return Object.keys(this.items).length;
  };


  Builder.prototype.subtotal = function () {
    var self = this;

    return Object.keys(this.items).reduce(function (total, key) {
      var item = self.items[key];
      return total + (item.price * item.quantity);
    }, 0);
  };


  Builder.prototype.currentTier = function () {
    var count = this.itemCount();
    var current = {
      count: 0,
      discount: 0
    };

    this.tiers.forEach(function (tier) {
      if (count >= tier.count) {
        current = tier;
      }
    });

    return current;
  };


  Builder.prototype.nextTier = function () {
    var count = this.itemCount();

    for (var i = 0; i < this.tiers.length; i++) {
      if (count < this.tiers[i].count) {
        return this.tiers[i];
      }
    }

    return null;
  };


  Builder.prototype.update = function () {
    var self = this;
    var count = this.itemCount();
    var subtotal = this.subtotal();
    var currentTier = this.currentTier();
    var discount = this.showSavings ? currentTier.discount : 0;
    var savings = Math.round(subtotal * (discount / 100));
    var total = Math.max(0, subtotal - savings);
    var nextTier = this.nextTier();

    if (this.empty) {
      this.empty.hidden = count > 0;
    }

    if (this.itemsWrap) {
      this.itemsWrap.innerHTML = Object.keys(this.items).map(function (key) {
        return self.itemMarkup(self.items[key]);
      }).join('');
    }

    if (this.subtotalNode) this.subtotalNode.textContent = this.money(subtotal);
    if (this.savingsNode) this.savingsNode.textContent = '-' + this.money(savings);
    if (this.totalNode) this.totalNode.textContent = this.money(total);

    var maxTierCount = this.tiers.length
      ? this.tiers[this.tiers.length - 1].count
      : this.minimumItems;

    var progress = clamp((count / Math.max(1, maxTierCount)) * 100, 0, 100);

    if (this.progressBar) {
      this.progressBar.style.width = progress + '%';
    }

    if (this.progressValue) {
      this.progressValue.textContent = Math.round(progress) + '%';
    }

    if (this.progressLabel) {
      if (discount > 0) {
        this.progressLabel.textContent = discount + '% bundle tier unlocked';
      } else if (count > 0) {
        this.progressLabel.textContent = count + ' product' + (count === 1 ? '' : 's') + ' selected';
      } else {
        this.progressLabel.textContent = 'Start your bundle';
      }
    }

    if (this.nextTierNode) {
      if (nextTier) {
        var remaining = nextTier.count - count;

        this.nextTierNode.textContent =
          'Add ' +
          remaining +
          ' more product' +
          (remaining === 1 ? '' : 's') +
          ' to reach the ' +
          nextTier.discount +
          '% tier.';
      } else if (count > 0 && currentTier.discount > 0) {
        this.nextTierNode.textContent =
          'You have reached the highest bundle tier.';
      } else if (count > 0) {
        this.nextTierNode.textContent =
          'Your bundle is ready when you are.';
      } else {
        this.nextTierNode.textContent =
          'Choose your first product to begin.';
      }
    }

    var ready = count >= this.minimumItems && !this.busy;

    if (this.checkout) {
      this.checkout.disabled = !ready;

      if (this.checkoutLabel) {
        if (count < this.minimumItems) {
          var need = this.minimumItems - count;

          this.checkoutLabel.textContent =
            'Add ' +
            need +
            ' more product' +
            (need === 1 ? '' : 's');
        } else {
          this.checkoutLabel.textContent = 'Add bundle to cart';
        }
      }
    }

    if (this.mobileCheckout) {
      this.mobileCheckout.disabled = !ready;
    }

    if (this.mobileCount) {
      this.mobileCount.textContent =
        count +
        ' product' +
        (count === 1 ? '' : 's');
    }

    if (this.mobileSaving) {
      if (discount > 0) {
        this.mobileSaving.textContent =
          'Save ' + discount + '% at this tier';
      } else if (nextTier && count > 0) {
        this.mobileSaving.textContent =
          'Add ' +
          (nextTier.count - count) +
          ' more for ' +
          nextTier.discount +
          '%';
      } else if (!count) {
        this.mobileSaving.textContent = 'Start building';
      } else {
        this.mobileSaving.textContent = 'Bundle selected';
      }
    }

    if (this.mobileTotal) {
      this.mobileTotal.textContent = this.money(total);
    }

    this.root.dispatchEvent(
      new CustomEvent('lw:bundle:updated', {
        bubbles: true,
        detail: {
          item_count: count,
          subtotal_cents: subtotal,
          estimated_savings_cents: savings,
          estimated_total_cents: total,
          tier_discount: discount
        }
      })
    );
  };


  Builder.prototype.itemMarkup = function (item) {
    var variant =
      item.variantTitle &&
      item.variantTitle !== 'Default Title'
        ? '<span>' + escapeHTML(item.variantTitle) + '</span>'
        : '<span>' + escapeHTML(item.concern) + '</span>';

    var image = item.image
      ? '<div class="lw-bundle-summary-item__image">' +
          '<img src="' + escapeHTML(item.image) + '" alt="" loading="lazy">' +
        '</div>'
      : '<div class="lw-bundle-summary-item__image"></div>';

    return (
      '<article class="lw-bundle-summary-item">' +
        image +
        '<div class="lw-bundle-summary-item__body">' +
          '<strong>' + escapeHTML(item.productTitle) + '</strong>' +
          variant +
        '</div>' +
        '<div>' +
          '<div class="lw-bundle-summary-item__price">' +
            escapeHTML(item.priceMoney) +
          '</div>' +
          '<button type="button" class="lw-bundle-summary-item__remove" ' +
          'data-lw-bundle-remove data-variant-id="' +
          escapeHTML(item.variantId) +
          '">Remove</button>' +
        '</div>' +
      '</article>'
    );
  };


  Builder.prototype.money = function (cents) {
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: this.currency,
        maximumFractionDigits: 2
      }).format((Number(cents) || 0) / 100);
    } catch (error) {
      return ((Number(cents) || 0) / 100).toFixed(2) + ' ' + this.currency;
    }
  };


  Builder.prototype.addBundleToCart = function () {
    var self = this;
    var count = this.itemCount();

    if (this.busy || count < this.minimumItems) return;

    this.busy = true;
    this.setError('');

    if (this.checkout) this.checkout.disabled = true;
    if (this.mobileCheckout) this.mobileCheckout.disabled = true;

    this.track('bundle_checkout_attempt', {
      item_count: count,
      tier_discount: this.currentTier().discount
    });

    var root =
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';

    var payload = Object.keys(this.items).map(function (key) {
      var item = self.items[key];

      return {
        id: Number(item.variantId),
        quantity: item.quantity,
        properties: {
          '_livvewell_bundle_builder': 'true',
          '_bundle_concern': item.concern
        }
      };
    });

    window.fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: payload
      })
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Unable to add the bundle to cart.');
        }

        return response.json();
      })
      .then(function () {
        self.busy = false;

        self.track('bundle_add_to_cart', {
          item_count: count,
          product_ids: Object.keys(self.items).map(function (key) {
            return self.items[key].productId;
          }),
          variant_ids: Object.keys(self.items),
          tier_discount: self.currentTier().discount
        });

        self.root.dispatchEvent(
          new CustomEvent('lw:bundle:added', {
            bubbles: true,
            detail: {
              item_count: count
            }
          })
        );

        self.closeMobileSummary();

        if (
          self.autoOpenCart &&
          window.LivvewellCartDrawer &&
          typeof window.LivvewellCartDrawer.open === 'function'
        ) {
          window.setTimeout(function () {
            window.LivvewellCartDrawer.open();
          }, 160);
        }

        self.update();
      })
      .catch(function (error) {
        self.busy = false;

        self.setError(
          error && error.message
            ? error.message
            : 'I could not add the bundle. Please try again.'
        );

        self.track('bundle_add_to_cart_error', {
          item_count: count
        });

        self.update();
      });
  };


  Builder.prototype.setError = function (message) {
    if (!this.errorNode) return;

    this.errorNode.textContent = message || '';
    this.errorNode.hidden = !message;
  };


  Builder.prototype.openMobileSummary = function () {
    if (!this.summary || window.innerWidth > 900) return;

    this.summary.classList.add('is-mobile-open');

    if (this.summaryBackdrop) {
      this.summaryBackdrop.hidden = false;
    }

    document.body.classList.add('lw-bundle-summary-open');

    this.track('bundle_summary_opened', {
      item_count: this.itemCount()
    });
  };


  Builder.prototype.closeMobileSummary = function () {
    if (!this.summary) return;

    this.summary.classList.remove('is-mobile-open');

    if (this.summaryBackdrop) {
      this.summaryBackdrop.hidden = true;
    }

    document.body.classList.remove('lw-bundle-summary-open');
  };


  Builder.prototype.openSupportFinder = function () {
    this.track('bundle_support_finder_opened', {
      item_count: this.itemCount()
    });

    if (
      window.LivvewellHelpbot &&
      window.LivvewellHelpbot.instances &&
      window.LivvewellHelpbot.instances[0] &&
      typeof window.LivvewellHelpbot.instances[0].open === 'function'
    ) {
      window.LivvewellHelpbot.instances[0].open();
      return;
    }

    var launcher = document.querySelector('[data-lw-helpbot-launcher]');

    if (launcher) {
      launcher.click();
    }
  };


  Builder.prototype.track = function (eventName, detail) {
    var payload = detail || {};

    this.root.dispatchEvent(
      new CustomEvent(eventName, {
        bubbles: true,
        detail: payload
      })
    );

    if (window.dataLayer && Array.isArray(window.dataLayer)) {
      var dataLayerPayload = {
        event: eventName
      };

      Object.keys(payload).forEach(function (key) {
        dataLayerPayload[key] = payload[key];
      });

      window.dataLayer.push(dataLayerPayload);
    }

    if (
      window.Shopify &&
      window.Shopify.analytics &&
      typeof window.Shopify.analytics.publish === 'function'
    ) {
      try {
        window.Shopify.analytics.publish(eventName, payload);
      } catch (error) {
        /* Do not interrupt the shopping experience if analytics is unavailable. */
      }
    }
  };


  function init(root) {
    if (!root || root.dataset.lwBundleReady === 'true') return;

    root.dataset.lwBundleReady = 'true';

    var instance = new Builder(root);

    API.instances.push(instance);
  }


  function initAll(scope) {
    qsa(scope || document, '[data-lw-bundle]').forEach(init);
  }


  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }


  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  API.init = init;
  API.initAll = initAll;
})();
